import React, { ChangeEventHandler } from "react";
import { MediumHeader } from "@narvar/nth-bit-header";
import SelectList from "@narvar/nth-select-list";
import LanguageKeys from "../../ReviewSummary/consts/language_en_US";
import { Language } from "../../ReviewSummary/components";

const tempLanguageKeys = {
  returnsReasonsQuantityTitle: LanguageKeys.returnsReasonsQuantityTitle,
  returnsReasonsItemInfoQuantitySelectPlaceholder:
    LanguageKeys.returnsReasonsItemInfoQuantitySelectPlaceholder,
};

const ReturnReasonsQuantity = ({
  quantity,
  onChange,
  totalQuantity,
}: {
  quantity?: number;
  onChange: (e: number) => void;
  totalQuantity: number | null;
}) => {
  const {
    returnsReasonsQuantityTitle,
    returnsReasonsItemInfoQuantitySelectPlaceholder,
  } = tempLanguageKeys;

  if (!totalQuantity) return null;

  const handleChange: ChangeEventHandler<HTMLSelectElement> = (e) => {
    onChange(Number.parseInt(e.target.value, 10));
  };

  return (
    <>
      <MediumHeader>
        <Language
          langKey="returnsReasonsQuantityTitle"
          defaultString={returnsReasonsQuantityTitle}
        />
      </MediumHeader>
      <SelectList onChange={handleChange} value={quantity}>
        <Language
          langKey="returnsReasonsItemInfoQuantitySelectPlaceholder"
          defaultString={returnsReasonsItemInfoQuantitySelectPlaceholder}
          tagName="option"
        />
        {Array(totalQuantity)
          .fill(undefined)
          .map((_, i) => {
            const value = i + 1;
            return (
              <option key={value} value={value}>
                {value}
              </option>
            );
          })}
      </SelectList>
    </>
  );
};

export default ReturnReasonsQuantity;
